// extracted by mini-css-extract-plugin
module.exports = {"notSupported":"ContentTypeNotSupportedPage_notSupported__NdBYE","type":"ContentTypeNotSupportedPage_type__DHHBS"};